import "../../resources/less/Troubadour/components/ThemesSlider.less";
import Glide, {
  Breakpoints,
  Controls,
  Swipe,
} from "@glidejs/glide/dist/glide.modular.esm";
import "@glidejs/glide/dist/css/glide.core.min.css";

export default class ThemesSlider {
  private themesCarousel: Glide;

  constructor() {
    this.initThemesCarousel();
  }

  private initThemesCarousel(): void {
    // The window-load hook below runs on every page that bundles this
    // module; without a slider in the DOM, Glide throws an uncaught
    // TypeError ("Root element must be a existing Html node").
    if (!$(".themes-slider-container").length) {
      return;
    }
    this.themesCarousel = new Glide(".themes-slider-container", {
      type: "carousel",
      startAt: 0,
      perView: 5,
      rewind: false,
      focusAt: "center",
      gap: 14,
      keyboard: true,
      breakpoints: {
        1999: {
          perView: 4,
        },
        1099: {
          perView: 2,
        },
        499: {
          perView: 1,
        },
      },
    });
    this.themesCarousel.mount({ Controls, Breakpoints, Swipe });
  }
}

$(window).on("load", () => {
  new ThemesSlider();
});
